import React from 'react';

import './styles.scss';

export function Loader({ isVisible }) {
    
    return (
        <div className={isVisible ? 'loader-bg' : 'loader-hide'} >
            <div className='loader-overlay'>
                <div className='loader-spinner'></div>
            </div>
        </div>
    );
}